import { render } from "./CollaborationView.vue?vue&type=template&id=b4c12c60&scoped=true"
import script from "./CollaborationView.vue?vue&type=script&lang=js"
export * from "./CollaborationView.vue?vue&type=script&lang=js"

import "./CollaborationView.vue?vue&type=style&index=0&id=b4c12c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c12c60"]])

export default __exports__